module.exports = __webpack_public_path__ + "img/Rogue-gnome-m-70.9d674dce.gif";